module.exports = __webpack_public_path__ + "static/media/signed-icon.fbbfba82.svg";